import { Injectable } from '@angular/core';

import { StorageKey } from './storage.constants';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly storage = window.localStorage;

  setToken(token: string): void {
    this.storage.setItem(StorageKey.TOKEN, token);
  }

  getToken(): string | null {
    return this.storage.getItem(StorageKey.TOKEN);
  }

  clear(): void {
    this.storage.clear();
  }
}
